import { useEditorStore } from "@/lib/stores/editor-store/editor-store";
import Tabs from "@/lib/components/Tabs";
import Captions from "./Captions/Captions";
import CreateVoiceoverTab from "./CreateVoiceoverTab";
import { VoiceoverView } from "@/lib/stores/editor-store/editor-state";
import EarlierVoiceovers from "./EarlierVoiceovers";

const voiceoverTabs = [
  { label: "AI Voiceover", value: "CREATE_VOICEOVER" as const },
  { label: "Captions", value: "CAPTIONS" as const },
];

function VoiceoverTab() {
  const updateVoiceoverTabState = useEditorStore(
    (state) => state.service.updateVoiceoverTabState,
  );
  const view = useEditorStore((state) => state.voiceoverTabState.view);

  if (view === "LIST") {
    return <EarlierVoiceovers />;
  }

  const currentTabValue: VoiceoverView =
    view === "CAPTIONS" ? "CAPTIONS" : "CREATE_VOICEOVER";

  return (
    <Tabs
      currentTab={currentTabValue}
      onTabClicked={(tab) => {
        updateVoiceoverTabState((state) => {
          state.view = tab;
        });
      }}
      options={voiceoverTabs}
      renderCurrentTab={(tab) => {
        if (tab === "CREATE_VOICEOVER") {
          return <CreateVoiceoverTab />;
        }

        if (tab === "CAPTIONS") {
          return <Captions />;
        }

        return null;
      }}
    />
  );
}

export default VoiceoverTab;
